module.exports = __webpack_public_path__ + "static/img/img-finance-sharinglist-wait-apply.bcd0561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/finance/sharinglist/img-finance-sharinglist-wait-apply.png
// module id = t6RM
// module chunks = 1